import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  Grid,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';

const EditSectionWiseMachine = ({ open, handleClose, fetchMachines, machine }) => {
  const [sectionName, setSectionName] = useState('');
  const [machineId, setMachineId] = useState(null);
  const [productId, setProductId] = useState(null);
  const [shiftCapacity, setShiftCapacity] = useState('');
  const [dayCapacity, setDayCapacity] = useState('');
  const [stepId, setStepId] = useState(null); // New state for StepId
  const [products, setProducts] = useState([]);
  const [machines, setMachines] = useState([]);
  const [steps, setSteps] = useState([]); // New state for steps

  // Fetch products
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
  }, []);

  // Fetch machines
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/machinelist`)
      .then((response) => {
        setMachines(response.data);
      })
      .catch((error) => {
        console.error('Error fetching machines:', error);
      });
  }, []);

  // Fetch steps
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-steps`)
      .then((response) => {
        setSteps(response.data);
      })
      .catch((error) => {
        console.error('Error fetching steps:', error);
      });
  }, []);

  // Populate fields when editing
  useEffect(() => {
    if (machine) {
      setSectionName(machine.SectionName || '');
      setMachineId(machines.find((m) => m.id === machine.MachineId) || null);
      setProductId(products.find((p) => p.id === machine.ProductId) || null);
      setStepId(steps.find((s) => s.step_id === machine.StepId) || null);
      setShiftCapacity(machine.ShiftCapacity || '');
      setDayCapacity(machine.DayCapacity || '');
    }
  }, [machine, machines, products, steps]);

  const handleSave = async () => {
    const updatedMachine = {
      SectionName: sectionName,
      MachineId: machineId?.id || '',
      ProductId: productId?.id || '',
      ShiftCapacity: shiftCapacity,
      DayCapacity: dayCapacity,
      StepId: stepId?.step_id || '', // Pass StepId to the backend
    };
    try {
      await axios.put(
        `${process.env.REACT_APP_PJCBACKEND_URL}/api/sectionwisemachine/${machine.id}`,
        updatedMachine
      );
      fetchMachines();
      handleClose();
    } catch (error) {
      console.error('Error updating machine:', error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6" align="center" gutterBottom>
          Edit Section Wise Machine
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Section Name"
          variant="outlined"
          fullWidth
          value={sectionName}
          onChange={(e) => setSectionName(e.target.value)}
          style={{ marginBottom: '20px' }}
        />

        <Grid item xs={12} style={{ marginBottom: '20px' }}>
          <Autocomplete
            options={machines}
            getOptionLabel={(machine) => machine.MachineName || ''}
            value={machineId}
            onChange={(event, newValue) => setMachineId(newValue)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Machine" placeholder="Machine" />
            )}
          />
        </Grid>

        <Grid item xs={12} style={{ marginBottom: '20px' }}>
          <Autocomplete
            options={products}
            getOptionLabel={(product) => product.product_name || ''}
            value={productId}
            onChange={(event, newValue) => setProductId(newValue)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Product" placeholder="Product" />
            )}
          />
        </Grid>

        <Grid item xs={12} style={{ marginBottom: '20px' }}>
          <Autocomplete
            options={steps}
            getOptionLabel={(step) => step.step_name || ''}
            value={stepId}
            onChange={(event, newValue) => setStepId(newValue)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Step" placeholder="Step" />
            )}
          />
        </Grid>

        <TextField
          label="Shift Capacity"
          variant="outlined"
          fullWidth
          value={shiftCapacity}
          onChange={(e) => setShiftCapacity(e.target.value)}
          style={{ marginBottom: '20px' }}
        />
        <TextField
          label="Day Capacity"
          variant="outlined"
          fullWidth
          value={dayCapacity}
          onChange={(e) => setDayCapacity(e.target.value)}
          style={{ marginBottom: '20px' }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditSectionWiseMachine;
